module.exports = __webpack_public_path__ + "img/calendar.4d12448c.svg";